import {api} from '../../contexts/AuthContext';

// Queue Admin API
export const queueApi = {
    getMetrics: async (): Promise<{
        pendingJobs: number;
        processingJobs: number;
        completedToday: number;
        failedToday: number;
        avgQueueTimeMs: number;
        avgProcessingTimeMs: number;
        tokensUsedToday: number;
        currentCapacityUsage: number;
    }> => {
        const response = await api.get('/api/queue-admin/metrics');
        return response.data;
    },

    getUserBreakdown: async (): Promise<{
        users: Array<{
            user_id: string | null;
            user_email: string | null;
            pending: number;
            processing: number;
            completed: number;
            failed: number;
            total: number;
        }>;
        total: {
            pending: number;
            processing: number;
            completed: number;
            failed: number;
            total: number;
        };
    }> => {
        const response = await api.get('/api/queue-admin/user-breakdown');
        return response.data;
    },

    getJobUsers: async (): Promise<Array<{
        user_id: string;
        user_email: string;
        job_count: number;
    }>> => {
        const response = await api.get('/api/queue-admin/users');
        return response.data;
    },

    getJobs: async (status?: string, userId?: string, limit: number = 50, offset: number = 0): Promise<{
        jobs: Array<{
            queue_id: string;
            status: string;
            job_type: string;
            analysis_type: string;
            priority: number;
            created_at: string;
            started_at?: string;
            completed_at?: string;
            error_message?: string;
            user_email?: string;
            company_name?: string;
        }>;
        total: number;
    }> => {
        const params = new URLSearchParams();
        if (status) params.append('status', status);
        if (userId) params.append('userId', userId);
        params.append('limit', limit.toString());
        params.append('offset', offset.toString());

        const response = await api.get(`/api/queue-admin/jobs?${params.toString()}`);
        return response.data;
    },

    getJobDetails: async (queueId: string): Promise<any> => {
        const response = await api.get(`/api/queue-admin/jobs/${queueId}`);
        return response.data;
    },

    cancelJob: async (queueId: string): Promise<{
        success: boolean;
        message: string;
    }> => {
        const response = await api.post(`/api/queue-admin/jobs/${queueId}/cancel`);
        return response.data;
    },

    getQueueStats: async (): Promise<{
        userQueue: {
            queueLength: number;
            activeWorkers: number;
            busyWorkers: number;
            maxWorkers: number;
            processing: boolean;
        };
        scheduledQueue: {
            queueLength: number;
            activeWorkers: number;
            busyWorkers: number;
            maxWorkers: number;
            processing: boolean;
            analyses?: Array<{
                analysisId: string;
                progress: string;
                pending: number;
                priority: number;
            }>;
        };
        timestamp: string;
    }> => {
        const response = await api.get('/api/queue/stats');
        return response.data;
    },

    getBlueprintUsage: async (search?: string, startDate?: string, endDate?: string): Promise<{
        success: boolean;
        usage: Array<{
            user_id: string;
            email: string;
            name: string;
            blueprint_count: number;
            last_blueprint_date: string | null;
        }>;
    }> => {
        const params = new URLSearchParams();
        if (search) params.append('search', search);
        if (startDate) params.append('startDate', startDate);
        if (endDate) params.append('endDate', endDate);

        const queryString = params.toString();
        const url = queryString ? `/api/queue-admin/blueprint-usage?${queryString}` : '/api/queue-admin/blueprint-usage';
        const response = await api.get(url);
        return response.data;
    }
};
